import { apiNotification } from "../api/notification";

const actionNotification = {
    getNotifications: (data) => apiNotification.get(data).then((response) => response),
    updateNotification: (data) => apiNotification.update(data).then((response) => response),
}

export default actionNotification;